<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />

    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement :info="basicRequirement" />
    <PositionSummary :info="positionInfo" />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../components/AssessmentIsa/AboutTheCompany.vue'

import TestimonialCompany from '../../components/AssessmentIsa/CompanyTestimonial.vue'
import Landing from '../../components/telmax/Landing.vue'
import ProgramInfo from '../../components/AssessmentIsa/ProgramInfo.vue'
import Contact from '../../components/isaMain/Contact.vue'
import PositionSummary from '../../components/AssessmentIsa/PositionSummary.vue'
import BasicRequirement from '../../components/AssessmentIsa/BasicReq.vue'
import Faq from '../../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title: 'Your first step towards a Senior Software Developer',
        paragraph:
          'Upskill presents this assessment only designed for Senior Software Developer with starting salary of Tk.1.2 -1.5 lac . The role will be remote and will have 3 months probation period. Once successfully completing the probation period, the candidate will be offered a full time position. The company will also provide visa support to place them in Canada after one year if performance is delivered',
        companyLogo: '',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/90cde046-592a-4239-84a1-c386e5d1dae3?public=true&job=SeniorFrontEnd01',
        landingImage: require('../../assets/telmax/Frame.png'),
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: '',
        info:
          'From the foundation, Canadian Tech company has been designing and building a cutting-edge telecommunications platform using the most advanced technology available.Since 2016, the Canadian Tech company team has been working hard to develop advanced phone systems, TV solutions and ultra-high speed 100% Pure Fiber internet services.',
        designation: '',

        bgColor: '#DDEAFA',
        txtColor: '#29292B',
      },
      programData: {
        headingInfo:
          'Assessment Test for the role of Software Developer at Canadian Tech company consists of approximately 10 MCQs. You are required to pass an assessment test with a minimum 60% of the total score.',
        seatsInfo:
          'Top 5-10 Candidates will get the chance to go to the interview round directly after completing the assessment.. So, don’t miss this opportunity as the time is limited!',
        startDate: '2nd February',
        cost: 'Free',
        deadline: '18th February',
        courseOutlineLink:
          'https://upskill-files.s3.ap-southeast-1.amazonaws.com/Financial+Analyst/Course+Outline+for+Financial+Analyst.pdf',

        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        bgColor: '#1EBCE5',
        txtColor: '#5277F7',
      },
      positionInfo: {
        paragraph:
          'Seeking a creative Sr. Software Developer with 5+ years of software development experience with web technologies including HTML5, CSS3 and JavaScript and Golang. You will apply software design principles and patterns to develop a suite of sales applications. Your extensive project experience and leadership will mentor junior developers. If you’re seeking a challenging role and striving to elevate your career, join the Canadian Tech company team!',
        remote: 'This is a remote position.',
        jobType: 'Job Type: Full-time (Remote)',
        txtColor: '#5277F7',
      },
      companyTestimonial: {
        // mainImg: require('../assets/Canadian Tech company/mgmt_zh.png'),
        // name: 'Zunaid Haroon',
        // paragraph:
        //   'Seeking a creative Sr. Software Developer with 5+ years of software development experience with web technologies including HTML5, CSS3 and JavaScript and Golang. You will apply software design principles and patterns to develop a suite of sales applications. Your extensive project experience and leadership will mentor junior developers. If you’re seeking a challenging role and striving to elevate your career, join the Canadian Tech company team!.',
        // designation: 'COO  of Canadian Tech company',
        // imgBg: '#DDEAFA',
        // invertedCommaBg: '',
        // firstComma: require('../assets/Canadian Tech company/“.svg'),
        // secondComma: require('../assets/Canadian Tech company/Group 22.svg'),
      },
      basicRequirement: {
        mainContent: [
          'Creative thinker with strong leadership and communication skills.',
          'Minimum 5+ years front-end/back-end development experience.',
          'Hands-on with SLDC.',
          'Hands-on with JavaScript, Golang, AngularJS and/or NodeJS.',
          'Hands-on with HTML5, CSS3, Bootstrap and/or Angular-Material.',
          'Hands-on with server-side scripting.',
          'Hands-on with NoSQL.',
          'Hands-on with DevOps.',
          'Hands-on ETL and data integration.',
          'Project experience with QA framework and process.',
          'Working knowledge of integration technologies/frameworks including AXIS, SOAP, JMS, HTTP, Socket, FTP, SMTP/POP.',
          'University degree in Computer Science or similar.',
          'Score 60% In The Initial Quiz',
        ],
        bgColor: '#184DBD',
      },

      outlineColor: {
        color: '#EA4424',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content:
            'Minimum 5+ years front-end/back-end development experience.. \n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score i.e. 6 out of 10',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        {
          title:
            'Will all the top 5 students get a job at Canadian Tech company?\n',
          content:
            'No, the top 5 students will get a chance to interview at Canadian Tech company, and will get the job depending on their performance in the interview.\n',
          category: 'FAQ',
        },
        {
          title: 'Salary?\n',
          content: ' 1.2 - 1.5 lac \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
    PositionSummary,
  },
  created() {
    this.Loaded()
  },
}
</script>
